import {
  QuerySearchMembersArgs,
  QuerySearchSpacesArgs,
  QuerySearchPostsArgs,
  QueryExternalSearchArgs,
} from '@tribeplatform/gql-client/types'
import {
  ExternalSearchResultFields,
  PaginatedMemberFields,
  PaginatedPostFields,
  PaginatedSpaceFields,
} from '@tribeplatform/gql-client/types/generated'

import { KeyConstructor } from './keyConstructor.js'

const SMART_SEARCH_POSTS_KEY = 'smartSearch-posts'
const SMART_SEARCH_INFINITE_POSTS_KEY = 'smartSearchInfinite-posts'
const SMART_SEARCH_SPACES_KEY = 'smartSearch-spaces'
const SMART_SEARCH_INFINITE_SPACES_KEY = 'smartSearchInfinite-spaces'
const SMART_SEARCH_MEMBERS_KEY = 'smartSearch-members'
const SMART_SEARCH_INFINITE_MEMBERS_KEY = 'smartSearchInfinite-members'
const SMART_SEARCH_EXTERNAL_KEY = 'smartSearch-external'

export const getSearchPostsKey = KeyConstructor<
  QuerySearchPostsArgs,
  PaginatedPostFields
>(SMART_SEARCH_POSTS_KEY)
export const getInfiniteSearchPostsKey = KeyConstructor<
  QuerySearchPostsArgs,
  PaginatedPostFields
>(SMART_SEARCH_INFINITE_POSTS_KEY)

export const getSearchSpacesKey = KeyConstructor<
  QuerySearchSpacesArgs,
  PaginatedSpaceFields
>(SMART_SEARCH_SPACES_KEY)

export const getInfiniteSearchSpacesKey = KeyConstructor<
  QuerySearchSpacesArgs,
  PaginatedSpaceFields
>(SMART_SEARCH_INFINITE_SPACES_KEY)

export const getSearchMembersKey = KeyConstructor<
  QuerySearchMembersArgs,
  PaginatedMemberFields
>(SMART_SEARCH_MEMBERS_KEY)

export const getInfiniteSearchMembersKey = KeyConstructor<
  QuerySearchMembersArgs,
  PaginatedMemberFields
>(SMART_SEARCH_INFINITE_MEMBERS_KEY)

export const getSearchExternalKey = KeyConstructor<
  QueryExternalSearchArgs,
  ExternalSearchResultFields
>(SMART_SEARCH_EXTERNAL_KEY)
